import { apiQuery } from '../';

export const companyApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      getCompany: builder.query({
        transformResponse: (response) => response?.data?.company,
        query: ({ companyId }) => {
          return {
            method: 'get',
            url: `/companies/${companyId}`,
          };
        },
      }),
    };
  },
  overrideExisting: true,
});
export const { useGetCompanyQuery } = companyApi;
